<template>
    <div>
        <el-row class="group-app-cards" :gutter="20">
            <el-col :span="12">
                <el-card class="box-card overview-panel mb20" v-loading="dataLoading.overviewLoading">
                    <div class="top">
                        <h3 class="inline-block mr32">集团概览</h3>
                        <el-select v-model="overviewForm.range_time_type" @change="getOverviewData" size="mini" class="select-no-border mr30" style="width: 90px;">
                            <el-option
                                v-for="item in rangeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="overviewForm.plat_id" @change="getOverviewData" size="mini" class="select-no-border mr30" style="width: 100px;">
                            <el-option value="" label="全部媒体"></el-option>
                            <el-option
                                v-for="item in platList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="overviewForm.cost_type" @change="getOverviewData" size="mini" class="select-no-border" style="width: 124px;">
                            <el-option value="" label="全部游戏类型"></el-option>
                            <el-option value="4" label="IAP-应用"></el-option>
                            <el-option value="3" label="IAA-应用"></el-option>
                            <el-option value="2" label="小游戏"></el-option>
                        </el-select>
                    </div>
                    <div class="middle clear-both">
                        <div class="fl">
                            <p style="line-height: 48px;">
                                <span class="mr20 font14px">在投集团数</span>
                                <span class="text-bold strong-text">{{overviewData.now_nums}}</span></p>
                        </div>
                        <div class="fl ml30">
                            <p>
                                <span class="mr20">环</span>
                                <span class="mr20 main-num-text">{{overviewData.ring_nums}}</span>
                                <!--<span class="mr20">{{overviewData.ring_rate|absVal}}</span>-->
                                <span class="mr20 rate-num-text text-color-success" v-if="overviewRingRate>0"> {{overviewData.ring_rate}} <i class="el-icon-top"></i></span>
                                <span class="mr20 rate-num-text text-color-error" v-else-if="overviewRingRate<0"> {{overviewData.ring_rate|absVal}} <i class="el-icon-bottom"></i></span>
                                <span class="mr20 rate-num-text pr20" v-else>{{overviewData.ring_rate}}</span>

                            </p>
                            <p>
                                <span class="mr20">同</span>
                                <span class="mr20 main-num-text">{{overviewData.same_nums}}</span>
                                <!--<span class="mr20">{{overviewData.same_rate|absVal}}</span>-->
                                <span class="mr20 rate-num-text text-color-success" v-if="overviewSameRate>0"> {{overviewData.same_rate}} <i class="el-icon-top"></i></span>
                                <span class="mr20 rate-num-text text-color-error" v-else-if="overviewSameRate<0"> {{overviewData.same_rate|absVal}} <i class="el-icon-bottom"></i></span>
                                <span class="mr20 rate-num-text pr20" v-else>{{overviewData.same_rate}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="bottom clear-both mt10" style="min-height: 150px;">
                        <div class="left-con fl">
                            <p class="cell-item cell-title no-border"></p>
                            <p class="cell-item cell-title" v-for="item in overviewListRow">
                                <span class="main-title inline-block">{{item}}</span>
                                <span class="sub-title">{{overviewList[item].range}}</span>
                            </p>
                        </div>
                        <div class="right-con fl">
                            <el-row>
                                <el-col :span="6" class="col-item" @click.native="showTips">
                                    <p class="cell-item">新投</p>

                                    <p class="cell-item" :key="'new_nums-'+item" v-for="item in overviewListRow">
                                        <span class="bg-bar" :style="{width:getValPercent(item,'new_nums')+'%'}"></span>
                                        {{overviewList[item].new_nums}}
                                    </p>
                                </el-col>
                                <el-col :span="6" class="col-item" @click.native="showTips">
                                    <p class="cell-item">复投</p>

                                    <p class="cell-item" :key="'rollback_nums-'+item" v-for="item in overviewListRow">
                                        <span class="bg-bar" :style="{width:getValPercent(item,'rollback_nums')+'%'}"></span>
                                        {{overviewList[item].rollback_nums}}
                                    </p>
                                </el-col>
                                <el-col :span="6" class="col-item" @click.native="showTips">
                                    <p class="cell-item">续投</p>

                                    <p class="cell-item" :key="'running_nums-'+item" v-for="item in overviewListRow">
                                        <span class="bg-bar" :style="{width:getValPercent(item,'running_nums')+'%'}"></span>
                                        {{overviewList[item].running_nums}}
                                    </p>
                                </el-col>
                                <el-col :span="6" class="col-item" @click.native="showTips">
                                    <p class="cell-item">停投</p>

                                    <p class="cell-item" :key="'stop_nums-'+item" v-for="item in overviewListRow">
                                        <span class="bg-bar" :style="{width:getValPercent(item,'stop_nums')+'%'}"></span>
                                        {{overviewList[item].stop_nums}}
                                    </p>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card loss-panel mb20" v-loading="dataLoading.lossLoading">
                    <div class="top">
                        <h3 class="inline-block mr32">集团流失情况</h3>
                        <el-radio-group v-model="lossForm.date_type" @change="getLossData" size="mini">
                            <el-radio-button label="2">按周</el-radio-button>
                            <el-radio-button label="1">按月</el-radio-button>
                        </el-radio-group>
                        <el-select v-model="lossForm.plat_id" @change="getLossData" placeholder="全部媒体" size="mini" class="select-no-border" style="width: 100px;">
                            <el-option value="" label="全部媒体"></el-option>
                            <el-option
                                v-for="item in platList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="lossForm.loss_type" @change="getLossData" placeholder="请选择" size="mini" class="select-no-border" style="width: 110px;">
                            <el-option value="7" label="7天流失"></el-option>
                            <el-option value="14" label="14天流失"></el-option>
                            <el-option value="30" label="30天流失"></el-option>
                        </el-select>
                    </div>
                    <div class="bottom">
                        <div class="loss-chart full-w" key="groupLossChart" id="groupLossChart" style="height: 230px;"></div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

     

    </div>


</template>

<script>
    import * as echarts from 'echarts';
    import API from '@/api/dashboard.js';


    export default {
        name: "GroupPanel",
        components:{
            
        },
        props:{
            platList:Array,
        },
        data(){
            return {
                dataLoading:{
                    overviewLoading:false,
                    lossLoading:false,
                    topLoading:false,
                },
                overviewForm:{
                    range_time_type:'benzhou',
                    plat_id:'',
                    cost_type:'',
                },
                rangeList:[
                    {
                        value: 'jinri',
                        label: '今日',
                    },
                    {
                        value: 'zuotian',
                        label: '昨日',
                    },
                    {
                        value: 'benzhou',
                        label: '本周',
                    },
                    {
                        value: 'shangzhou',
                        label: '上周',
                    },
                    {
                        value: 'benyue',
                        label: '本月',
                    },
                    {
                        value: 'shangyue',
                        label: '上月',
                    },
                    {
                        value: 'benji',
                        label: '本季',
                    },
                    {
                        value: 'shangji',
                        label: '上季',
                    },
                    {
                        value: 'bennian',
                        label: '今年',
                    },
                ],

                overviewData:{
                    now_nums:'',
                    ring_nums:'',
                    same_nums:'',
                    ring_rate:'',
                    same_rate:'',
                },
                overviewList:{},
                overMaxData:{
                    max_new_nums:null,
                    max_rollback_nums:null,
                    max_running_nums:null,
                    max_stop_nums:null,
                },
                lossForm:{
                    date_type:'1',
                    plat_id:'',
                    loss_type:'7',
                },

                lossChart:null,
                lossData:{
                    loss_num: {},
                    loss_rate: {},
                    date: [],
                    date_str:{},
                },
            }
        },
        computed:{
            overviewListRow(){
                return Object.keys(this.overviewList);
            },
            overviewRingRate(){
                return parseFloat(this.overviewData.ring_rate||0);
            },
            overviewSameRate(){
                return parseFloat(this.overviewData.same_rate||0);
            },
        },
        filters:{
            absVal(val){
                if(val==='--') return val;
                if(!val) return '';
                return (val+'').replace(/^-/,'');
            }
        },
        mounted(){
            window.addEventListener("resize", this.resizeChart);
        },
        methods:{
            getPanelDate(){
                this.getOverviewData();
                this.getLossData();
                this.getTopData();
            },
            getOverviewData(){
                this.overviewData = {
                    now_nums:'',
                    ring_nums:'',
                    same_nums:'',
                    ring_rate:'',
                    same_rate:'',
                };
                this.overMaxData = {
                    max_new_nums:null,
                    max_rollback_nums:null,
                    max_running_nums:null,
                    max_stop_nums:null,
                };

                this.overviewList = {};

                this.dataLoading.overviewLoading = true;
                API.getMediaGroupOverview({
                    range_time_type:this.overviewForm.range_time_type,
                    cost_type:this.overviewForm.cost_type,
                    plat_id:this.overviewForm.plat_id,
                }).then(res=>{
                    let resData = res.data||{};

                    this.overMaxData.max_new_nums = resData.max_new_nums;
                    this.overMaxData.max_rollback_nums = resData.max_rollback_nums;
                    this.overMaxData.max_running_nums = resData.max_running_nums;
                    this.overMaxData.max_stop_nums = resData.max_stop_nums;

                    this.overviewData.now_nums = resData.now_nums;
                    this.overviewData.ring_nums = resData.ring_nums;
                    this.overviewData.same_nums = resData.same_nums;
                    this.overviewData.ring_rate = resData.ring_rate;
                    this.overviewData.same_rate = resData.same_rate;

                    this.overviewList = resData.list||{};


                    this.dataLoading.overviewLoading = false;
                },err=>{
                    console.log('getMediaGroupOverview err',err);

                    this.dataLoading.overviewLoading = false;
                    this.$message.error(err.info||'请求失败')
                })
            },
            getValPercent(item,type){
                let itemData = this.overviewList[item]||{};
                let itemVal = itemData[type];
                let baseMaxVal = this.overMaxData['max_'+type]||0;
                if(!itemVal||!baseMaxVal) return 0;
                return parseInt(itemVal/baseMaxVal*100)||0;
            },
            getLossData(){
                this.dataLoading.lossLoading = true;
                API.getMediaGroupLoss({
                    date_type:this.lossForm.date_type,
                    plat_id:this.lossForm.plat_id,
                    loss_type:this.lossForm.loss_type,
                }).then(res=>{
                    let resData = res.data||{};

                    this.lossData.date = resData.date||[];
                    this.lossData.loss_num = resData.loss_num||{};
                    this.lossData.loss_rate = resData.loss_rate||{};
                    this.lossData.date_str = resData.date_str||{};

                    this.initLossChart();

                    this.dataLoading.lossLoading = false;
                },err=>{
                    console.log('getMediaGroupLoss err',err);

                    this.dataLoading.lossLoading = false;
                    this.$message.error(err.info||'请求失败')
                })
            },
            initLossChart(){
                let $chart = document.getElementById('groupLossChart');
                if(!$chart) return;

                if(!this.lossChart){
                    this.lossChart = echarts.init($chart);
                }

                let lossType = this.lossForm.loss_type;
                let option = {
                    color:['#9ff4ec','#96c8ff'],
                    legend: {
                        top:20,
                        data: [lossType+'天流失数量',lossType+'天流失率'],
                    },
                    tooltip: {
                        show:true,
                        trigger: 'axis',
                        // formatter:'{b}<br />{a0}: {c0}<br />{a1}: {c1}%',
                        formatter:(params)=>{
                            let name = params[0].name;
                            let dateStr = this.lossData.date_str[name];
                            let dataStr = '';
                            params.forEach(item=>{
                                let rateStr = item.seriesIndex==1?'%':'';
                                dataStr += '<p>'+item.seriesName+'：'+item.data+rateStr+'</p>';
                            });
                            return `<p>${name}（${dateStr}）</p>`+dataStr;
                        },
                        appendToBody:true,
                    },
                    grid:{
                        left: '3%',
                        right: '4%',
                        bottom: '4%',
                        containLabel: true,
                    },
                    xAxis: {
                        type: 'category',
                        data: this.lossData.date||[],
                    },
                    yAxis: [
                        {
                            type: 'value',
                            axisLine:{
                                show:true,
                            }
                        },
                        {
                            type: 'value',
                            axisLabel: {
                                show: true,
                                interval: 'auto',
                                formatter: '{value} %'//纵坐标百分比
                            },
                            axisLine:{
                                show:true,
                            },
                            splitLine:{
                                show:false,
                            }
                        }
                    ],
                    series: [
                        {
                            name:lossType+'天流失数量',
                            yAxisIndex:0,
                            data: Object.values(this.lossData.loss_num||{}),
                            type: 'bar',
                            barMaxWidth:20,
                        },
                        {
                            name:lossType+'天流失率',
                            yAxisIndex:1,
                            data: Object.values(this.lossData.loss_rate||{}).map(item=>parseFloat(item)),
                            type: 'line',
                        }
                    ]
                };

                this.lossChart.setOption(option,true);

                this.resizeChart();
            },
            getTopData(){
                console.log('getTopData');
            },
            showTips(){
                this.$message.warning('功能设计开发中，敬请期待...');
            },
            resizeChart(){
                if(this.lossChart){
                    this.lossChart.resize();
                }
            },
        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    this.resizeChart();
                },200);
            },
        },
        beforeDestroy(){
            // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
            if(this.marketChart){
                this.marketChart.dispose();
            }
            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>

    ::v-deep.select-no-border input{
        border: none;
    }

    .overview-panel{
        min-height: 268px;
        .left-con{
            width: 140px;
            margin-right: 10px;
        }
        .right-con{
            width: calc(100% - 150px);
        }

        .middle{
            padding: 10px 0;
            border-bottom: 1px dashed #ccc;

            .main-num-text{
                display: inline-block;
                min-width: 80px;
                text-align: right;
            }
            .rate-num-text{
                display: inline-block;
                min-width: 80px;
                text-align: right;
            }
        }

        .col-item{
            cursor: pointer;
            padding: 0 5px;
            &:hover{
                background-color: #81d3f826;
            }
        }
        .cell-item{
            margin: 10px 0;
            height: 18px;
            line-height: 18px;
            position: relative;
            overflow: hidden;
            z-index: 1;
            .main-title{
                width: 36px;
            }
            .sub-title{
                color: #ccc;
            }

            &.cell-title{
                border-right: solid 2px #797979;
            }
            &.no-border{
                border: none;
            }
            .bg-bar{
                display: block;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background-color: #9ff4ec;
                z-index: -1;
                border-radius: 0 3px 3px 0;
            }
        }

        .strong-text{
            font-size: 18px;
        }
    }



</style>
